export const iconsTheme = {
    home: 'fas fa-home',
    code: 'fas fa-code',
    moneyCheckAlt: 'fas fa-money-check-alt',
    exclamationCircle: 'fas fa-exclamation-circle',
    chartPie: 'fas fa-chart-pie',
    users: 'fas fa-users',
    cog: 'fas fa-cog',
    lifeRing: 'fas fa-life-ring',
    creditCard: 'fas fa-credit-card',
    calendar: 'fas fa-calendar-alt',
    briefcase: 'fas fa-briefcase',
    singleConsumer: 'fas fa-user',
    singleConsumerStyle: 'fas fa-user',
    notification: '',
    clock: '',
    star: 'fas fa-star',
    clipboard: 'fas fa-clipboard',
    cogs: 'fas fa-cogs',
    check: 'fas fa-check',
    ban: 'fas fa-ban',
    clockTwo: 'fas fa-clock',
    question: '',
    bell: 'fas fa-bell',
    exchange: 'fas fa-exchange',
    outdentBar: '',
    indentBar: '',
    bars: '',
    document: '',
    toggleUnlock: 'icon-toggle-unlock',
    toggleLock: 'icon-toggle-lock',
    edit: 'icon-edit',
    midPermission: 'icon-mid-permission',
    sitePermission: 'icon-site-permission',
    tempPassword: 'icon-temp-password',
    trashCan: 'icon-trash-can',
    wheel: 'fas fa-cogs',
    flagged: '',
    unflagged: '',
    assign: '',
    cross: '',
    inProgress: '',
    win: '',
    loss: '',
    upload: 'icon-upload',
    solidLock: 'fas fa-lock',
    download: 'fas fa-download',
    eye: 'fas fa-eye',
}
